<template>
  <v-col cols="12">
    <v-navigation-drawer
      id="app-drawer"
      v-model="drawer"
      :mini-variant="responsive ? false : mini"
      mini-variant-width="75"
      app
      dark
      floating
      persistent
      touchless
      :permanent="!responsive"
      :temporary="responsive"
      :mobile-breakpoint="MOBILE_BREAKPOINT"
      width="250"
    >
      <v-layout class="fill-height" tag="v-list" column style="overflow-y: auto;">
        <v-list-item
        id="drawer-header-item"
        to="/dashboard"
        ref="headerImage"
        active-class="white--text active-drawer-item drawer-header-item"
        :ripple="{ class: rippleClass }">
          <v-img
          style="z-index: 1;"
          text-align="center"
          min-width="50"
          max-height="100"
          :min-height="responsive ? 0 : mini ? 50 : 35"
          contain
          :class="{ 'mini-drawer-logo': !responsive && mini }"
          :src="responsive || !mini ? logoSvg : miniLogoSvg"
          max-width="90%"/>
        </v-list-item>
        <v-divider :style="{ borderColor: `${isDashboardRoute ? '#00000000' : ''}` }"/>
        <div :class="isFinancialDropdownRoute ? 'activeHeader' : ''">
          <v-list-group
            active-class="white--text"
            ref="financialDropdown"
            v-model="isFinancialDropdown"
            @click="handleFinancialDrawerClick"
            :ripple="{ class: 'grey--text text--darken-1' }"
          >
            <template #activator>
              <v-list-item-icon :class="isFinancialDropdownRoute ? 'ml-n1' : ''">
                <v-tooltip bottom color="primary">
                  <template #activator="{ on }">
                    <v-icon color="white" v-on="on">mdi-finance</v-icon>
                  </template>
                  <span class="subtitle-1 white--text" style="white-space: pre-line">
                    {{$t('accounting')}}
                  </span>
                </v-tooltip>
              </v-list-item-icon>
              <v-list-item-title>
                {{$t('accounting')}}
              </v-list-item-title>
            </template>
            <div class="dropdown-content">
              <v-list-item
              to="/current-payables"
              ref="payables"
              active-class="white--text active-drawer-item"
              :ripple="{ class: rippleClass }"
              id="drawer-list-item"
              class="mb-2">
                <v-list-item-icon>
                  <Icon
                  iconColor="white"
                  dataTestId="drawer-payables"
                  :small="false"
                  :tooltipText="$t('payables')"
                  icon="mdi-bank-transfer-out"/>
                </v-list-item-icon>
                <v-list-item-title>
                  {{$t('payables')}}
                </v-list-item-title>
              </v-list-item>
              <v-list-item
              to="/accounts-receivable"
              ref="receivable"
              active-class="white--text active-drawer-item"
              :ripple="{ class: rippleClass }"
              id="drawer-list-item">
                <v-list-item-icon>
                  <Icon
                  iconColor="white"
                  dataTestId="drawer-receivables"
                  :small="false"
                  :tooltipText="$t('receivables')"
                  icon="mdi-bank-transfer-in"/>
                </v-list-item-icon>
                <v-list-item-title>
                  {{$t('receivables')}}
                </v-list-item-title>
              </v-list-item>
              <v-list-item
              to="/accruals"
              ref="accruals"
              active-class="white--text active-drawer-item"
              :ripple="{ class: rippleClass }"
              id="drawer-list-item">
                <v-list-item-icon>
                  <Icon
                  iconColor="white"
                  dataTestId="drawer-accruals"
                  :small="false"
                  :tooltipText="$t('accruals')"
                  icon="mdi-bank-transfer"/>
                </v-list-item-icon>
                <v-list-item-title>
                  {{$t('accruals')}}
                </v-list-item-title>
              </v-list-item>
              <v-list-item
              to="/settlements"
              ref="settlements"
              active-class="white--text active-drawer-item"
              :ripple="{ class: rippleClass }"
              id="drawer-list-item">
                <v-list-item-icon>
                  <Icon
                  iconColor="white"
                  dataTestId="drawer-settlements"
                  :small="false"
                  :tooltipText="$t('settlements')"
                  icon="mdi-file-check"/>
                </v-list-item-icon>
                <v-list-item-title>
                  {{$t('settlements')}}
                </v-list-item-title>
              </v-list-item>
              <v-list-item
              to="/balances"
              ref="balances"
              active-class="white--text active-drawer-item"
              :ripple="{ class: rippleClass }"
              id="drawer-list-item">
                <v-list-item-icon>
                  <Icon
                  iconColor="white"
                  :small="false"
                  :tooltipText="$t('balances')"
                  icon="mdi-scale-unbalanced"/>
                </v-list-item-icon>
                <v-list-item-title>
                  {{ $t('balances') }}
                </v-list-item-title>
              </v-list-item>
            </div>
          </v-list-group>
        </div>

        <v-list-item
          to="/tickets"
          ref="ticket"
          active-class="white--text active-drawer-item"
          :ripple="{ class: rippleClass }"
          id="drawer-list-item">
            <v-list-item-icon>
              <Icon
              iconColor="white"
              dataTestId="drawer-tickets"
              :small="false"
              :tooltipText="$t('tickets')"
              icon="mdi-clipboard-outline"/>
            </v-list-item-icon>
            <v-list-item-title>
              {{$t('tickets')}}
            </v-list-item-title>
        </v-list-item>

        <div :class="isContractDropdownRoute ? 'mt-2 activeHeader' : 'pb-2'">
          <v-list-group
          active-class="white--text"
          ref="contractDropdown"
          v-model="isContractDropdown"
          @click="handleContractDrawerClick"
          :ripple="{ class: 'grey--text text--darken-1' }"
          >
          <template #activator>
            <v-list-item-icon :class="isContractDropdownRoute ? 'ml-n1' : ''">
                <v-tooltip bottom color="primary">
                  <template #activator="{ on }">
                    <v-icon color="white" v-on="on">mdi-altimeter</v-icon>
                  </template>
                  <span class="primary subtitle-1 white--text" style="white-space: pre-line">
                    {{$t('contracts')}}
                  </span>
                </v-tooltip>
              </v-list-item-icon>
              <v-list-item-title>
                {{$t('contracts')}}
              </v-list-item-title>
          </template>
          <div class="dropdown-content">
              <v-list-item
              to="/contracts"
              ref="contractSetup"
              active-class="white--text active-drawer-item"
              :ripple="{ class: rippleClass }"
              id="drawer-list-item"
              class="mb-2">
                <v-list-item-icon>
                  <Icon
                  iconColor="white"
                  dataTestId="drawer-setup"
                  :small="false"
                  :tooltipText="$t('setup')"
                  icon="mdi-file-sign"/>
                </v-list-item-icon>
                <v-list-item-title>
                  {{$t('setup')}}
                </v-list-item-title>
              </v-list-item>
              <v-list-item
              to="/contract-quota"
              ref="contractQuota"
              active-class="white--text active-drawer-item"
              :ripple="{ class: rippleClass }"
                  id="drawer-list-item">
                <v-list-item-icon>
                  <Icon
                  iconColor="white"
                  dataTestId="drawer-analysis"
                  :small="false"
                  :tooltipText="$t('quota')"
                  icon="mdi-counter"/>
                </v-list-item-icon>
                <v-list-item-title>
                  {{$t('quota')}}
                </v-list-item-title>
              </v-list-item>
            </div>
          </v-list-group>
        </div>

        <div :class="`${isTractDropdownRoute ? 'mt-2 activeHeader' : 'pb-2'}`">
          <v-list-group
            active-class="white--text"
            ref="tractDropdown"
            v-model="isTractDropdown"
            @click="handleTractDrawerClick"
            :ripple="{ class: 'grey--text text--darken-1' }"
          >
            <template #activator>
              <v-list-item-icon :class="isTractDropdownRoute ? 'ml-n1' : ''">
                <v-tooltip bottom color="primary">
                  <template #activator="{ on }">
                    <v-icon color="white" v-on="on">mdi-crosshairs-gps</v-icon>
                  </template>
                  <span class="primary subtitle-1 white--text" style="white-space: pre-line">
                    {{$t('tracts')}}
                  </span>
                </v-tooltip>
              </v-list-item-icon>
              <v-list-item-title>
                {{$t('tracts')}}
              </v-list-item-title>
            </template>
            <div class="dropdown-content">
              <v-list-item
              to="/tracts"
              ref="tractSetup"
              active-class="white--text active-drawer-item"
              :ripple="{ class: rippleClass }"
              id="drawer-list-item"
              class="mb-2">
                <v-list-item-icon>
                  <Icon
                  iconColor="white"
                  dataTestId="drawer-setup"
                  :small="false"
                  :tooltipText="$t('setup')"
                  icon="mdi-crosshairs"/>
                </v-list-item-icon>
                <v-list-item-title>
                  {{$t('setup')}}
                </v-list-item-title>
              </v-list-item>
              <v-list-item
              to="/tract-analysis"
              ref="tractAnalysis"
              active-class="white--text active-drawer-item"
              :ripple="{ class: rippleClass }"
                  id="drawer-list-item">
                <v-list-item-icon>
                  <Icon
                  iconColor="white"
                  dataTestId="drawer-analysis"
                  :small="false"
                  :tooltipText="$t('analysis')"
                  icon="mdi-chart-timeline-variant"/>
                </v-list-item-icon>
                <v-list-item-title>
                  {{$t('analysis')}}
                </v-list-item-title>
              </v-list-item>
              <v-list-item
              v-if="showTractDueDiligence"
              to="/tract-due-diligence"
              ref="tractDueDiligence"
              active-class="white--text active-drawer-item"
              :ripple="{ class: rippleClass }"
                  id="drawer-list-item">
                <v-list-item-icon>
                  <Icon
                  iconColor="white"
                  dataTestId="drawer-tract-due-diligence"
                  :small="false"
                  :tooltipText="$t('dueDiligence')"
                  icon="mdi-clipboard-text-search-outline"/>
                </v-list-item-icon>
                <v-list-item-title>
                  {{$t('dueDiligence')}}
                </v-list-item-title>
              </v-list-item>
            </div>
          </v-list-group>
        </div>

        <v-list-item
          to="/accounts"
          ref="accounts"
          active-class="white--text active-drawer-item"
          :ripple="{ class: rippleClass }"
          id="drawer-list-item">
            <v-list-item-icon>
              <Icon
              iconColor="white"
              dataTestId="drawer-accounts"
              :small="false"
              :tooltipText="$t('accounts')"
              icon="mdi-account"/>
            </v-list-item-icon>
            <v-list-item-title>
              {{$t('accounts')}}
            </v-list-item-title>
        </v-list-item>

        <MovingArrow v-if="arrowVisible" :move-y="arrowLocation" :isMini="responsive ? false : mini"/>
      </v-layout>

      <template #append>
        <v-list-item>
          <v-list-item-icon id="pendo-activator">
            <v-img :src="angelLogoSvg" width="24"></v-img>
          </v-list-item-icon>
          <v-spacer/>
          <v-list-item-title style="text-align: right;">
            <v-icon v-if="responsive" @click="closeDrawer">
              mdi-chevron-double-left
            </v-icon>
          </v-list-item-title>
      </v-list-item>
      </template>
    </v-navigation-drawer>
  </v-col>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import { LocalStorageKeys } from '@/utils/LocalStorageActor'
import { MOBILE_BREAKPOINT } from '@/utils/DeviceUtility'
import { UserClaims } from '@/utils/Enumerations.js'
import { userAssignedClaim } from '@/utils/ClaimUtility'
import { endangeredSpeciesEnabled } from '@/utils/dueDiligence/mode.js'

export default {
  name: 'Drawer',

  props: {
    openFirstByDefault: {
      type: Boolean,
      default: false,
      required: false
    },
    propDrawer: {
      type: Boolean
    }
  },

  data: () => ({
    MOBILE_BREAKPOINT,
    responsive: false,
    linkHeight: 65,
    arrowVisible: true,
    arrowLocation: 0,
    financeDrawerOpen: false,
    logoSvg: './img/Legna-Secondary-WHITE.svg',
    miniLogoSvg: './img/Legna-Icon-WHITE.svg',
    angelLogoSvg: './img/angel-logo.svg',
    isFinancialDropdown: false,
    isContractDropdown: false,
    isTractDropdown: false,
    arrowGeneralOffset: -115,
    arrowDropdownOffset: -110,
    arrowWeirdFinancialDropdownOffset: -285,
    minimumDropdownAnimationTime: 270,
    drawer: null
  }),

  components: {
    MovingArrow: () => import('./MovingArrow.vue'),
    Icon: () => import('@/components/helper/Icon.vue')
  },

  watch: {
    currentRoute () {
      this.foldDrawers()
      this.moveArrow()
    },
    isFinancialDropdown () {
      this.moveArrowOnFinancialDropdown()
    },
    isContractDropdown () {
      this.moveArrowOnContractDropdown()
    },
    isTractDropdown () {
      this.moveArrowOnTractDropdown()
    },
    mini (val) {
      localStorage.setItem(LocalStorageKeys.DRAWER_MINI, val)
    },
    propDrawer (val) {
      if (val) {
        this.drawer = true
      }
    },
    drawer (val) {
      this.$emit('drawerChanged', val)
    }
  },
  computed: {
    ...mapState('app', ['image', 'color', 'mini']),
    currentRoute () {
      return this.$route.path
    },

    arrowStatus () {
      let isNotInDropdown = false
      let isInFinancialDropdown = false
      let isInContractDropdown = false
      let isInTractDropdown = false
      if (this.drawerItems.find(({ path }) => path === this.currentRoute)) {
        isNotInDropdown = true
      } else if (this.financialNestedElements.find(({ path }) => path === this.currentRoute)) {
        isInFinancialDropdown = true
      } else if (this.contractNestedElements.find(({ path }) => path === this.currentRoute)) {
        isInContractDropdown = true
      } else if (this.tractNestedElements.find(({ path }) => path === this.currentRoute)) {
        isInTractDropdown = true
      }
      return {
        isNotInDropdown: isNotInDropdown,
        isInFinancialDropdown: isInFinancialDropdown,
        isInContractDropdown: isInContractDropdown,
        isInTractDropdown: isInTractDropdown
      }
    },
    financialNestedElements () {
      return [
        {
          path: '/current-payables',
          ref: 'payables'
        },
        {
          path: '/accounts-receivable',
          ref: 'receivable'
        },
        {
          path: '/accruals',
          ref: 'accruals'
        },
        {
          path: '/settlements',
          ref: 'settlements'
        },
        {
          path: '/balances',
          ref: 'balances'
        }
      ]
    },
    contractNestedElements () {
      return [
        {
          path: '/contracts',
          ref: 'contractSetup'
        },
        {
          path: '/contract-quota',
          ref: 'contractQuota'
        }
      ]
    },
    tractNestedElements () {
      const elements = [
        {
          path: '/tracts',
          ref: 'tractSetup'
        },
        {
          path: '/tract-analysis',
          ref: 'tractAnalysis'
        }
      ]
      if (this.showTractDueDiligence) {
        elements.push({
          path: '/tract-due-diligence',
          ref: 'tractDueDiligence'
        })
      }
      return elements
    },

    showTractDueDiligence () {
      return userAssignedClaim(UserClaims.SustainabilityAdmin) && endangeredSpeciesEnabled()
    },
    drawerItems () {
      return [
        {
          path: '/dashboard',
          ref: 'headerImage'
        },
        {
          text: this.$t('accounting'),
          icon: 'mdi-finance',
          nestedElements: this.financialNestedElements
        },
        {
          path: '/tickets',
          ref: 'ticket'
        },
        {
          icon: 'mdi-altimeter',
          text: this.$t('contracts'),
          nestedElements: this.contractNestedElements
        },
        {
          icon: 'mdi-crosshairs-gps',
          text: this.$t('tracts'),
          nestedElements: this.tractNestedElements
        },
        {
          path: '/accounts',
          ref: 'accounts'
        }
      ]
    },

    isContractDropdownRoute () {
      return this.contractNestedElements.map(f => f.path).some(path => this.$route.fullPath === path)
    },

    isTractDropdownRoute () {
      return this.tractNestedElements.map(f => f.path).some(path => this.$route.fullPath === path)
    },

    isFinancialDropdownRoute () {
      return this.financialNestedElements.map(f => f.path).some(path => this.$route.fullPath === path)
    },

    isDashboardRoute () {
      return this.drawerItems.find(di => di.path.includes('dashboard')).path === this.$route.fullPath
    },

    rippleClass () {
      return 'primary--text'
    }
  },
  created () {
    if (localStorage.getItem(LocalStorageKeys.DRAWER_MINI)) {
      this.setMini(localStorage.getItem(LocalStorageKeys.DRAWER_MINI) === 'true')
    }
    this.foldDrawers()
  },
  mounted () {
    this.onResponsiveInverted()
    window.addEventListener('resize', this.onResponsiveInverted)
    if (this.financialNestedElements.find(({ path }) => path === this.currentRoute)) {
      this.moveArrowOnTractDropdown()
    } else if (this.tractNestedElements.find(({ path }) => path === this.currentRoute)) {
      this.moveArrowOnFinancialDropdown()
    } else if (this.contractNestedElements.find(({ path }) => path === this.currentRoute)) {
      this.moveArrowOnContractDropdown()
    } else {
      this.moveArrow()
    }
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.onResponsiveInverted)
  },
  methods: {
    ...mapMutations('app', ['setMini']),
    foldDrawers () {
      this.isTractDropdown = this.isTractDropdownRoute
      this.isFinancialDropdown = this.isFinancialDropdownRoute
      this.isContractDropdown = this.isContractDropdownRoute
    },
    handleContractDrawerClick () {
      if (!this.openFirstByDefault) return
      const targetPath = '/contracts'
      if (!this.isContractDropdown && !this.isContractDropdownRoute) this.$router.push(targetPath)
    },
    handleTractDrawerClick () {
      if (!this.openFirstByDefault) return
      const targetPath = '/tracts'
      if (!this.isTractDropdown && !this.isTractDropdownRoute) this.$router.push(targetPath)
    },
    handleFinancialDrawerClick () {
      if (!this.openFirstByDefault) return
      const targetPath = '/current-payables'
      if (!this.isFinancialDropdown && !this.isFinancialDropdownRoute) this.$router.push(targetPath)
    },
    onResponsiveInverted () {
      if (window.innerWidth < MOBILE_BREAKPOINT) {
        this.responsive = true
        this.arrowVisible = false
      } else {
        this.responsive = false
        if (window.innerHeight >= 760) {
          this.arrowVisible = true
        } else {
          this.arrowVisible = false
        }
      }
    },
    moveArrow (timeOut) {
      if (!timeOut) { timeOut = 0 }
      setTimeout(() => {
        if (this.currentRoute === '/dashboard') {
          this.arrowLocation = -1 * ((this.$refs.headerImage.$el.getBoundingClientRect().top + this.$refs.headerImage.$el.getBoundingClientRect().bottom) / 2)
        } else if (this.currentRoute !== '/settings') {
          let currentDrawerObj
          if (this.arrowStatus.isNotInDropdown) {
            currentDrawerObj = this.drawerItems.find(({ path }) => path === this.currentRoute)
          } else if (this.arrowStatus.isInFinancialDropdown) {
            currentDrawerObj = this.financialNestedElements.find(({ path }) => path === this.currentRoute)
          } else if (this.arrowStatus.isInContractDropdown) {
            currentDrawerObj = this.contractNestedElements.find(({ path }) => path === this.currentRoute)
          } else {
            currentDrawerObj = this.tractNestedElements.find(({ path }) => path === this.currentRoute)
          }
          this.setArrowLocation(currentDrawerObj?.ref, this.arrowGeneralOffset)
        }
      }, timeOut)
    },
    moveArrowOnContractDropdown () {
      if (this.isTractDropdown && this.isFinancialDropdown && this.isContractDropdown) { return }
      if (this.arrowStatus.isInFinancialDropdown && !this.isFinancialDropdown) {
        this.setArrowLocation('financialDropdown', this.arrowDropdownOffset)
        return
      }
      if (this.arrowStatus.isInTractDropdown && !this.isTractDropdown) {
        this.setArrowLocation('tractDropdown', this.arrowDropdownOffset, this.minimumDropdownAnimationTime)
        return
      }
      if (this.arrowStatus.isInContractDropdown && !this.isContractDropdown) {
        this.setArrowLocation('contractDropdown', this.arrowDropdownOffset, this.minimumDropdownAnimationTime)
      } else {
        this.moveArrow(this.minimumDropdownAnimationTime)
      }
    },
    moveArrowOnTractDropdown () {
      if (this.isTractDropdown && this.isFinancialDropdown && this.isContractDropdown) { return }
      if (this.arrowStatus.isInFinancialDropdown && !this.isFinancialDropdown) {
        this.setArrowLocation('financialDropdown', this.arrowDropdownOffset)
        return
      }
      if (this.arrowStatus.isInContractDropdown && !this.isContractDropdown) {
        this.setArrowLocation('contractDropdown', this.arrowDropdownOffset)
        return
      }
      if (this.arrowStatus.isInTractDropdown && !this.isTractDropdown) {
        this.setArrowLocation('tractDropdown', this.arrowDropdownOffset, this.minimumDropdownAnimationTime)
      } else {
        this.moveArrow(this.minimumDropdownAnimationTime)
      }
    },
    moveArrowOnFinancialDropdown () {
      if (this.isTractDropdown && this.isFinancialDropdown && this.isContractDropdown) { return }
      if (this.arrowStatus.isInTractDropdown && !this.isTractDropdown) {
        if (!this.isFinancialDropdown) {
          this.setArrowLocation('tractDropdown', this.arrowDropdownOffset, this.minimumDropdownAnimationTime)
        } else {
          this.setArrowLocation('tractDropdown', this.arrowDropdownOffset, this.minimumDropdownAnimationTime)
        }
        return
      }
      if (this.arrowStatus.isInContractDropdown && !this.isContractDropdown) {
        this.setArrowLocation('contractDropdown', this.arrowDropdownOffset, this.minimumDropdownAnimationTime)
        return
      }
      if (this.arrowStatus.isInFinancialDropdown && !this.isFinancialDropdown) {
        this.setArrowLocation('financialDropdown', this.arrowWeirdFinancialDropdownOffset)
      } else {
        this.moveArrow(this.minimumDropdownAnimationTime)
      }
    },
    setArrowLocation (ref, offset, timeOut) {
      if (!timeOut) { timeOut = 0 }
      setTimeout(() => {
        this.arrowLocation = ((this.$refs[ref].$el.getBoundingClientRect().top + this.$refs[ref].$el.getBoundingClientRect().bottom) / 2) + offset
      }, timeOut)
    },
    closeDrawer () {
      this.drawer = false
    }
  }
}
</script>

<style>
#app-drawer .v-list__item {
  border-radius: 4px;
}

#app-drawer .v-list__item--buy {
  margin-top: auto;
  margin-bottom: 17px;
}

#app-drawer .mini-drawer-logo .v-image__image--contain {
  top: 9px;
  height: 60%;
}

#app-drawer .search-input {
  margin-bottom: 30px !important;
  padding-left: 15px;
  padding-right: 15px;
}

#drawer-list-item {
  max-height: 60px;
}

#accounts-payable {
  max-height: 60px;
}

#drawer-header-item {
  max-height: 90px;
}

.drawer-header-item {
  background: #d1602700;
}

.dropdown-content {
  box-shadow: 0px 0px 5px #333 inset;
  background-color: #505050;
  margin-top: 6px;
  padding-top: 2px;
  padding-bottom: 8px;
}

#app-drawer .v-list-item--link:before {
  opacity: 0;
}

#app-drawer .v-list-item__title {
  z-index: 1;
}

#app-drawer .v-list-item--link.secondary{
  background-color: #d16027;
  transition: .5s linear;
}

#app-drawer .v-list-item {
  margin: 10px 0px 0;
  padding: 0px 30px 0
}

#app-drawer .activeHeader .v-list-group__header {
  margin: 10px 0px 0;
  padding: 0px 30px 0;
  border-left: 4px solid rgba(255,255,255,.2);
  background-color: rgba(255,255,255,.2);
  transition: background-color .2s;
}

#app-drawer .activeHeader .v-list-group__header:not(.v-list-item--active) {
  margin: 10px 0px 0;
  padding: 0px 30px 0;
  border-left: 4px solid transparent;
  background-color: #00000000;
  transition: background-color .2s;
}

#app-drawer .v-icon--link {
  z-index: 1; /* Prevents ripple from appearing over the icon */
}

#app-drawer .v-list-group__header:not(.active-drawer-item):hover {
  background-color: #ffffff11;
  transition: background-color .2s;
}
</style>

<style scoped>
.v-navigation-drawer .v-list .v-list-item:not(:nth-child(3)) {
  margin: 10px 15px 0;
}
.v-navigation-drawer .v-list .v-list-item:nth-child(3) {
  margin: 0 15px;
}
#app-drawer .active-drawer-item {
  background-color: #d15f2755;
  border-left: 4px solid #d15f27;
  padding-left: 26px;
  transition: .2s;
}
#app-drawer .v-list-item--link:not(.active-drawer-item) {
  border-left: 4px solid transparent;
  padding-left: 26px;
  transition: background-color .2s;
}
#app-drawer .v-list-item--link:not(.active-drawer-item):hover {
  background-color: #d15f2722;
  transition: background-color .2s;
}
</style>
